import styled from 'styled-components';

import {
  SkeletonFormField as SkeletonFormFieldComponent,
  SkeletonHeadline as SkeletonHeadlineComponent,
  SkeletonBodyCopy as SkeletonBodyCopyComponent,
} from '@xing-com/skeleton';
import { spaceM, spaceS, spaceXL, spaceXXL } from '@xing-com/tokens';
import { BodyCopy as BodyCopyComponent } from '@xing-com/typography';

export const BodyCopy = styled(BodyCopyComponent)`
  margin: ${spaceXL} 0 ${spaceM};
`;

export const FormFieldContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  & > li:not(:last-child) {
    margin-bottom: ${spaceM};
  }
`;

export const CharacterCounter = styled.span`
  display: block;
  margin-bottom: -${spaceS};
`;

export const SkeletonHeadline = styled(SkeletonHeadlineComponent)`
  margin-bottom: ${spaceXXL};
`;

export const SkeletonBodyCopy = styled(SkeletonBodyCopyComponent)`
  margin-bottom: ${spaceM};
`;

export const SkeletonFormField = styled(SkeletonFormFieldComponent)`
  margin-bottom: ${spaceM};
`;
